var m = Object.defineProperty;
var r = Object.getOwnPropertySymbols;
var n = Object.prototype.hasOwnProperty, H = Object.prototype.propertyIsEnumerable;
var o = (C, e, l) => e in C ? m(C, e, { enumerable: !0, configurable: !0, writable: !0, value: l }) : C[e] = l, V = (C, e) => {
  for (var l in e || (e = {}))
    n.call(e, l) && o(C, l, e[l]);
  if (r)
    for (var l of r(e))
      H.call(e, l) && o(C, l, e[l]);
  return C;
};
var c = (C, e) => {
  var l = {};
  for (var t in C)
    n.call(C, t) && e.indexOf(t) < 0 && (l[t] = C[t]);
  if (C != null && r)
    for (var t of r(C))
      e.indexOf(t) < 0 && H.call(C, t) && (l[t] = C[t]);
  return l;
};
import * as a from "react";
const w = (t) => {
  var i = t, {
    title: C,
    titleId: e
  } = i, l = c(i, [
    "title",
    "titleId"
  ]);
  return /* @__PURE__ */ a.createElement("svg", V({ width: 32, height: 32, viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": e }, l), C ? /* @__PURE__ */ a.createElement("title", { id: e }, C) : null, /* @__PURE__ */ a.createElement("path", { d: "M3.075 2.5C2.20547 2.5 1.5 3.21387 1.5 4.09375V16.7188C1.5 17.5986 2.20547 18.3125 3.075 18.3125H3.6C3.6 20.0723 5.01094 21.5 6.75 21.5C8.48906 21.5 9.9 20.0723 9.9 18.3125H14.1C14.1 20.0723 15.5109 21.5 17.25 21.5C18.9891 21.5 20.4 20.0723 20.4 18.3125H21.45C22.0308 18.3125 22.5 17.8377 22.5 17.25C22.5 16.6623 22.0308 16.1875 21.45 16.1875V13.0625V12V11.3791C21.45 10.8146 21.2302 10.2734 20.8364 9.875L18.3 7.3084C17.9062 6.90996 17.3714 6.6875 16.8136 6.6875H15.15V4.09375C15.15 3.21387 14.4445 2.5 13.575 2.5H3.075ZM15.15 8.8125H16.8136L19.35 11.3791V12H15.15V8.8125ZM5.175 18.3125C5.175 17.8898 5.34094 17.4844 5.63631 17.1855C5.93168 16.8867 6.33228 16.7188 6.75 16.7188C7.16772 16.7188 7.56832 16.8867 7.86369 17.1855C8.15906 17.4844 8.325 17.8898 8.325 18.3125C8.325 18.7352 8.15906 19.1406 7.86369 19.4395C7.56832 19.7383 7.16772 19.9062 6.75 19.9062C6.33228 19.9062 5.93168 19.7383 5.63631 19.4395C5.34094 19.1406 5.175 18.7352 5.175 18.3125ZM17.25 16.7188C17.6677 16.7188 18.0683 16.8867 18.3637 17.1855C18.6591 17.4844 18.825 17.8898 18.825 18.3125C18.825 18.7352 18.6591 19.1406 18.3637 19.4395C18.0683 19.7383 17.6677 19.9062 17.25 19.9062C16.8323 19.9062 16.4317 19.7383 16.1363 19.4395C15.8409 19.1406 15.675 18.7352 15.675 18.3125C15.675 17.8898 15.8409 17.4844 16.1363 17.1855C16.4317 16.8867 16.8323 16.7188 17.25 16.7188Z" }));
};
export {
  w as default
};
